import styled from 'styled-components';
import SecondaryButton from '@carvana/showroom-forms/Button/Secondary';
import { LinkWithNativeEvents } from '../link/link';

// header

export const ManufacturerHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
  width: 100%;
  max-width: 1800px;
  background: #ffffff;
  position: relative;
`;
export const ManufacturerHeaderLeftSideWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const ManufacturerHeaderRightSideWrapper = styled.span`
  position: absolute;
  right: 0;
`;
export const ManufacturerHeaderTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1800px;
  background: #ffffff;
  text-align: left;
  width: 100%;
`;
export const ManufacturerHeaderWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const ManufacturerWarrantiesHeaderRowItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-right: 0;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    // // margin-right: 48px;
    // margin-bottom: 24px;

    flex-direction: row;
    align-items: center;
    min-width: 300px;
  }

  @media (min-width: 1024px) {
    min-width: 336px;
  }
`;

// content

export const ManufacturerContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom: 24px;
  margin: 0;
  width: 100%;
  background: #ffffff;

  @media (min-width: 768px) {
    flex-wrap: nowrap;
  }
`;
export const ManufacturerContentLeftSideWrapper = styled.span`
  display: flex;
  flex-direction: row;

  @media (min-width: 768px) {
    margin-right: 40px;
  }
`;
export const ManufacturerContentRightSideWrapper = styled.span`
  display: flex;
  flex-direction: row;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;
export const ManufacturerContentWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  margin: 0 auto 16px auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const ManufacturerContentPowerWarrantiesRow = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  margin: 24px auto 16px auto;
  max-width: 1800px;
  background: #ffffff;

  @media (min-width: 769px) {
    flex-direction: row;
  }
`;
export const ManufacturerWarrantiesContentRowItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  //   margin-right: 48px;
  //   margin-bottom: 24px;
  margin-right: 0;
  margin-bottom: 0;

  @media (min-width: 769px) {
    flex-direction: row;
    align-items: center;
    margin-right: 0;
    margin-bottom: 0;
  }
`;
export const ManufacturerContentTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  font-size: 14px;
  line-height: 20px;
`;

// text

export const ManufacturerBoldText = styled.span`
  font-weight: 700;
  color: #183558;
`;

export const ManufacturerText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #6d7184;
`;

export const ManufacturerExpiredText = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 4px 0 0 0;
  line-height: 20px;
  color: #6d7184;
`;
export const ManufacturerGreyText = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 2px 16px;
  line-height: 20px;
  color: #6d7184;
  border-radius: 3px;

  @media (max-width: 375px) {
    padding: 2px;
  }
`;
export const ManufacturerGreyList = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding: 4px 8px;
  color: #6d7184;
  background: #f4f8fa;
  width: auto;
`;
export const ManufacturerLinkText = styled(LinkWithNativeEvents)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

// button

export const ManufacturerContentButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-top: 24px;
  width: 100%;

  @media (min-width: 769px) {
    margin-top: 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: auto;
  }
`;
export const ManufacturerButton = styled(SecondaryButton)`
  display: flex;
  padding: 12px 24px;
  min-width: 180px;
  min-height: 40px;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  width: 100%;
  min-width: auto !important;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 200px !important;
    width: auto;
  }
`;

// miscellaneous

export const ManufacturerIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 22px 0 2px;
  max-width: 1800px;
  background: #ffffff;
`;
export const ManufacturerChevronIconWrapper = styled.span<{ isOpen: any }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 6px;
  // padding-right: 12px;

  & svg {
    transition: transform 0.5s;
    transform: ${(props) => (props.isOpen === true ? 'rotate(180deg)' : 'rotate(0deg)')};
  }
`;
export const ManufacturerTitle = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #183558;
  margin-bottom: 12px;
`;
export const ManufacturerRowItemExpiredWarrantyWrapper = styled.span`
  display: block;
`;
export const ManufacturerRowItemWarrantyWrapper = styled.span`
  background: #f4f8fa;

  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    justify-content: center;
  }
`;

export const ManufacturerWarrantyLabel = styled.span`
  font-weight: 700;
  color: #183558;
  margin-bottom: 8px;

  @media (min-width: 769px) {
    margin-bottom: 0;
    margin-right: 8px;
  }
`;

export const HideText = styled.span`
  @media (max-width: 375px) {
    display: none;
  }
`;

export const ListWrapper = styled.ul`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  padding-left: 24px;
  margin: 8px 0 0px;
  list-style: none;
`;

export const ListItem = styled.li`
  margin-top: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  position: relative;

  &::before {
    content: '•';
    color: #183558;
    font-weight: normal;
    display: inline-block;
    width: 18px;
    margin-left: -18px;
    text-align: left;
    font-size: 20px;
  }
`;
